import type { TrayView } from '@repo/common/types/Tray';
import { getHandler } from '../sharedlib';
import { trayView } from '../stores/tray.store';

// Receives the entire TrayView state and updates the store. In the future, consider using delta updates.
export const setupTrayEvent = async () => {
  const handler = getHandler();
  const unlisten = await handler.createTauriListener('setTray', (data: TrayView) => {
    trayView.set(data);
  });
  return unlisten;
};

// Sends the entire TrayView state to the tray. In the future, consider using delta updates.
export const sendToTray = async (payload: TrayView) => {
  const handler = getHandler();
  await handler.emitEvent('setTray', payload);
};
